import { API } from 'aws-amplify';

const query = /* GraphQL */ `query AdminConsoleQuery($action: String!, $input: AWSJSON) {
  adminConsoleQuery(action: $action, input: $input)
}`;
const mutation = /* GraphQL */ `mutation AdminConsoleMutation($action: String!, $input: AWSJSON) {
  adminConsoleMutation(action: $action, input: $input)
}`;
export async function adminRequest(action, input = {}, write = false) {
  const field = write ? 'adminConsoleMutation' : 'adminConsoleQuery';
  const result = await API.graphql({ query: write ? mutation : query, variables: { action, input: JSON.stringify(input) }, authMode: 'AMAZON_COGNITO_USER_POOLS' });
  // AWSJSON can arrive single- or double-encoded depending on whether the
  // Lambda returned an object or a pre-stringified payload; unwrap both.
  let value = result.data[field];
  for (let i = 0; i < 2 && typeof value === 'string'; i++) value = JSON.parse(value);
  return value;
}
export function adminError(error) {
  const message = error.errors?.[0]?.message || error.message || 'The request failed. Please try again.';
  return /ConditionalCheckFailed/.test(message) ? 'This record changed. Reload it before saving again.' : message;
}
